import React, { useState, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import Loader from '@bufferapp/ui/Loader'

import { Wrapper } from './styles'

// @ts-expect-error TS(7006) FIXME: Parameter 'element' implicitly has an 'any' type.
function inView(element) {
  if (!element) return false

  const rect = element.getBoundingClientRect()
  const { clientWidth, clientHeight } = document.documentElement

  return rect.top <= (window.innerHeight || clientHeight)
}

/**
 *
 */
// @ts-expect-error TS(7031) FIXME: Binding element 'target' implicitly has an 'any' t... Remove this comment to see the full error message
const LoadMore = ({ target, onLoad }) => {
  const [loading, setLoading] = useState(false)
  const loadMoreRef = useRef(null)

  useEffect(() => {
    setLoading(false)
    target.addEventListener('scroll', onScroll)

    // We need to make sure the scrolling behaviour is
    // also triggered if the number of posts displayed per page
    // is not enough to fill the grid.
    onScroll()
  }, [onLoad])

  useEffect(() => {
    if (!loading) return
    onLoad()
    target.removeEventListener('scroll', onScroll)
  }, [loading])

  const onScroll = () => {
    if (inView(loadMoreRef.current) && !loading) {
      setLoading(true)
    }
  }

  return <Wrapper ref={loadMoreRef}>{loading && <Loader />}</Wrapper>
}

LoadMore.propTypes = {
  onLoad: PropTypes.func,
}

export default LoadMore
